import { render, staticRenderFns } from "./InboxListPlayer.vue?vue&type=template&id=1641f2ff"
import script from "./InboxListPlayer.vue?vue&type=script&lang=js"
export * from "./InboxListPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports